import classNames from 'classnames'
import noop from '../utils/noop'
import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'

export default class PaginatorPage extends PureComponent {
  static propTypes = {
    onClick: PropTypes.func,
    page: PropTypes.number.isRequired,
    selected: PropTypes.bool.isRequired
  }

  static defaultProps = {
    onClick: noop
  }

  constructor(props) {
    super(props)

    this.handleClick = this.handleClick.bind(this)
  }

  handleClick(e) {
    e.preventDefault()
    this.props.onClick(e)
  }

  renderPageNumber() {
    const { selected, page } = this.props

    if (selected) {
      return page
    } else {
      return <a onClick={this.handleClick}>{page}</a>
    }
  }

  render() {
    const { selected } = this.props
    const classes = classNames('page', {
      current: selected
    })

    return <span data-qv-pagination={classes}>{this.renderPageNumber()}</span>
  }
}



// WEBPACK FOOTER //
// ../src/components/PaginatorPage.js